import React from 'react'
import * as Yup from 'yup'

const formView = (defaultValues, value) => [
  {
    name: 'product_SKU',
    label: 'Product SKU',
    placeholder: 'Enter SKU',
    type: 'Input',
    className: 'w-[90%]',
    defaultValue: defaultValues?.product_profile_name,
    validation: Yup.string().required('SKU is required'),
  }
]

export default formView
